"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("../Button"));
const Link_1 = __importDefault(require("../Link"));
const Heading_1 = __importDefault(require("../Heading"));
const Section_1 = __importDefault(require("../Section"));
const NavigationListMenu_1 = __importDefault(require("../NavigationListMenu"));
const NavigationListMenuItem_1 = __importDefault(require("../NavigationListMenu/NavigationListMenuItem"));
const Grid_1 = __importDefault(require("../Grid"));
const analyticsUtils_1 = require("../../utils/analyticsUtils");
const testUtils_1 = require("../../utils/testUtils");
const config_1 = __importDefault(require("./config"));
const SocialLinks_1 = __importDefault(require("./subcomponents/SocialLinks"));
const NewsletterSignupSection_1 = __importDefault(require("../NewsletterSignupSection"));
const styles = require('./Footer.module.scss');
const FooterLink = ({ section: { action, category, isOpenInNewWindow, path, rel, text }, }) => (react_1.default.createElement(Link_1.default, { className: styles.a, color: "white", href: path, rel: rel, target: isOpenInNewWindow ? '_blank' : '_self', trackingAttributes: {
        category,
        action,
        label: text.toLowerCase(),
    } }, text));
const FooterSection = ({ children, isDesktop, section: { path, sections }, section }) => (react_1.default.createElement(Grid_1.default, { item: true, key: path, lg: 3 },
    react_1.default.createElement(NavigationListMenu_1.default, { className: styles.navigationListMenu },
        react_1.default.createElement(NavigationListMenuItem_1.default, { className: styles.navigationListMenuItem, showDivider: false },
            react_1.default.createElement(Heading_1.default, { className: styles.heading, level: "4" }, path.length ? react_1.default.createElement(FooterLink, { section: section }) : section.text)),
        sections &&
            sections.map((subSection) => {
                const { hideDesktop } = subSection;
                if (hideDesktop && isDesktop) {
                    return undefined;
                }
                return (react_1.default.createElement(NavigationListMenuItem_1.default, { className: styles.navigationListMenuItem, showDivider: false, key: `${subSection.text}${path}` },
                    react_1.default.createElement(FooterLink, { section: subSection })));
            }),
        children)));
const AboutSection = ({ isDesktop }) => (react_1.default.createElement(FooterSection, { section: config_1.default.sections.about, isDesktop: isDesktop },
    react_1.default.createElement(NavigationListMenuItem_1.default, { className: styles.navigationListMenuItem },
        react_1.default.createElement(Button_1.default, Object.assign({ className: styles.advertisingPreferences, appearance: "link", onClick: analyticsUtils_1.handleAdvertisingClick }, (0, testUtils_1.getDataTypeAttribute)({ typeId: 'advertizing-preferences' })), config_1.default.advertisingPreferences))));
const Footer = ({ hideNewsletterSignup }) => (react_1.default.createElement(react_1.default.Fragment, null,
    !hideNewsletterSignup && react_1.default.createElement(NewsletterSignupSection_1.default, null),
    config_1.default && (react_1.default.createElement("footer", { className: styles.footer },
        react_1.default.createElement(Section_1.default, { type: "nav" },
            react_1.default.createElement("div", { className: styles.mobileOnly },
                react_1.default.createElement(Grid_1.default, { container: true },
                    react_1.default.createElement(Grid_1.default, { item: true, md: 6, lg: 3, style: { paddingTop: 0, paddingBottom: 0 } },
                        react_1.default.createElement(AboutSection, null),
                        react_1.default.createElement(SocialLinks_1.default, null),
                        react_1.default.createElement("p", { className: styles.p }, config_1.default.copyright),
                        react_1.default.createElement("p", { className: styles.p }, config_1.default.trademark),
                        react_1.default.createElement("p", { className: styles.p }, config_1.default.registeredAddress)))),
            react_1.default.createElement("div", { className: styles.desktopOnly },
                react_1.default.createElement(Grid_1.default, { container: true },
                    react_1.default.createElement(Grid_1.default, { item: true, md: 6, lg: 3, style: { paddingTop: 0, paddingBottom: 0 } },
                        react_1.default.createElement(FooterSection, { section: config_1.default.sections.buy }),
                        react_1.default.createElement(FooterSection, { section: config_1.default.sections.news })),
                    react_1.default.createElement(Grid_1.default, { item: true, md: 6, lg: 3, style: { paddingTop: 0, paddingBottom: 0 } },
                        react_1.default.createElement(FooterSection, { section: config_1.default.sections.sell }),
                        react_1.default.createElement(FooterSection, { section: config_1.default.sections.forums })),
                    react_1.default.createElement(Grid_1.default, { item: true, md: 6, lg: 3, style: { paddingTop: 0, paddingBottom: 0 } },
                        react_1.default.createElement(FooterSection, { section: config_1.default.sections.services }),
                        react_1.default.createElement(AboutSection, { isDesktop: true })),
                    react_1.default.createElement(Grid_1.default, { item: true, md: 6, lg: 3, style: { paddingTop: 0, paddingBottom: 0 } },
                        react_1.default.createElement(SocialLinks_1.default, null),
                        react_1.default.createElement("p", { className: styles.p }, config_1.default.copyright),
                        react_1.default.createElement("p", { className: styles.p }, config_1.default.trademark),
                        react_1.default.createElement("p", { className: styles.p }, config_1.default.registeredAddress),
                        react_1.default.createElement("p", { className: styles.p },
                            "This site is protected by reCAPTCHA and the Google",
                            ' ',
                            react_1.default.createElement(Link_1.default, { color: "light-grey", href: "https://policies.google.com/privacy", target: "_blank" }, "Privacy Policy"),
                            ' ',
                            "and",
                            ' ',
                            react_1.default.createElement(Link_1.default, { color: "light-grey", href: "https://policies.google.com/terms", target: "_blank" }, "Terms of Service"),
                            ' ',
                            "apply.")))))))));
exports.default = (0, react_1.memo)(Footer);
//# sourceMappingURL=Footer.js.map